import { Link } from 'react-router';
import { APP_NAME } from '@vuokramani/shared';
import logo from '../assets/logo.png';
import logoDark from '../assets/logo-tumma.png';
import s from './shell.module.css';

/** Pieni merkki (logon talo): puhelimen yläpalkki ja selaimen välilehti (favicon.svg). */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg className={s.brandMark} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#17343a" />
      <path
        d="M6.2 14.2 16 5.2l9.8 9"
        fill="none"
        stroke="#fff"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9 23.6 16.4V25.8a1.2 1.2 0 0 1-1.2 1.2H18.6V21.6a1 1 0 0 0-1-1h-3.2a1 1 0 0 0-1 1V27H9.6a1.2 1.2 0 0 1-1.2-1.2V16.4Z"
        fill="#fff"
      />
    </svg>
  );
}

/**
 * Logo. Kaksi kuvaa: tumma teksti vaalealle pohjalle ja vaalea tummalle.
 * CSS valitsee teeman ja paikan mukaan (sivupaneeli on aina tumma).
 */
export function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className={s.brand} aria-label={APP_NAME}>
      <img className={s.logoLight} src={logo} alt="" height={24} />
      <img className={s.logoDark} src={logoDark} alt="" height={24} />
    </Link>
  );
}
